var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalyticsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.00455726 8.71331C-0.0388803 9.06288 0.233737 9.37152 0.586003 9.37152H2.96983C3.25597 9.37152 3.50026 9.16484 3.54765 8.88261C4.00643 6.15038 6.15034 4.00643 8.88257 3.54768C9.1648 3.5003 9.37148 3.256 9.37148 2.96983V0.586003C9.37148 0.233737 9.06288 -0.0388803 8.71327 0.00455726C6.51522 0.277722 4.43874 1.29409 2.86639 2.86639C1.29409 4.43874 0.277721 6.51523 0.00455726 8.71331Z",
    fill: "#9C9EA9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.7334 15.2606C12.6213 16.0547 11.3173 16.4744 9.96234 16.4744C6.77401 16.4744 4.07628 14.1896 3.54768 11.0416C3.5003 10.7595 3.256 10.5527 2.96987 10.5527H0.586003C0.233737 10.5527 -0.0388803 10.8613 0.00455726 11.2109V11.2109C0.627253 16.2213 4.90815 19.9997 9.96234 19.9997C12.2139 19.9997 14.3432 19.2689 16.1201 17.8863C16.3982 17.6698 16.4237 17.2587 16.1746 17.0095L14.4882 15.3232C14.2857 15.1207 13.9665 15.0942 13.7334 15.2606Z",
    fill: "#9C9EA9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.0417 3.54768C14.1896 4.07628 16.4745 6.77401 16.4745 9.96234C16.4745 11.3173 16.0547 12.6213 15.2607 13.7334C15.0943 13.9665 15.1207 14.2857 15.3232 14.4882L17.0097 16.1746C17.2588 16.4238 17.67 16.3982 17.8864 16.1201L17.8864 16.1201C19.269 14.3433 19.9997 12.2139 19.9997 9.96234C19.9997 4.90815 16.2214 0.627253 11.211 0.00455726H11.2109C10.8614 -0.0388803 10.5527 0.233737 10.5527 0.586003V2.96983C10.5528 3.256 10.7595 3.5003 11.0417 3.54768Z",
    fill: "#9C9EA9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.353 5.93555H9.57129C9.2477 5.93555 8.98535 6.19789 8.98535 6.52148V13.3573H10.9389V6.52148C10.9389 6.19789 10.6766 5.93555 10.353 5.93555Z",
    fill: "#9C9EA9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.1104 13.3574H13.478C13.8016 13.3574 14.0639 13.095 14.0639 12.7714V8.08398C14.0639 7.76039 13.8016 7.49805 13.478 7.49805H12.1104V13.3574Z",
    fill: "#9C9EA9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M7.81344 9.06055H6.44727C6.12367 9.06055 5.86133 9.32289 5.86133 9.64648V12.7714C5.86133 13.095 6.12367 13.3574 6.44727 13.3574H7.81344V9.06055Z",
    fill: "#9C9EA9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsIcon);
export default __webpack_public_path__ + "static/media/analyticsIcon.a5dc463e0a77879c8818655261436e04.svg";
export { ForwardRef as ReactComponent };